import { atom } from "jotai";

/**
 * Atom to track when room actions (take, handoff, close, etc.) are in progress.
 * When true, prevents chat messages from being sent to avoid race conditions.
 */
export const roomActionsInProgressAtom = atom<boolean>(false);
